import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 生产商
 */
const manufacturer = {

  /**
   * 新增生产商
   */
  addManufacturer (name, address, tel) {
    return axios.post(base.manufacturer.addManufacturer, utils.postParamsArrayToJsonString({ name, address, tel }))
  },
  /**
   * 修改生产商
   */
  modifyManufacturer (id, name, address, tel) {
    return axios.post(base.manufacturer.modifyManufacturer, utils.postParamsArrayToJsonString({ id, name, address, tel }))
  },
  /**
   * 查询生产商
   */
  getManufacturer (id) {
    return axios.post(base.manufacturer.getManufacturer, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询生产商
   */
  getManufacturer2 (name) {
    return axios.post(base.manufacturer.getManufacturer2, utils.postParamsArrayToJsonString({ name }))
  },
  /**
   * 删除生产商
   */
  deleteManufacturer (id) {
    return axios.post(base.manufacturer.deleteManufacturer, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 新增设备型号
   */
  addDeviceModel (manufacturerId, name, model) {
    return axios.post(base.manufacturer.addDeviceModel, utils.postParamsArrayToJsonString({ manufacturerId, name, model }))
  },
  /**
   * 修改设备型号
   */
  modifyDeviceModel (modelId, name, model) {
    return axios.post(base.manufacturer.modifyDeviceModel, utils.postParamsArrayToJsonString({ modelId, name, model }))
  },
  /**
   * 查询设备型号
   */
  getDeviceModel (modelId) {
    return axios.post(base.manufacturer.getDeviceModel, utils.postParamsArrayToJsonString({ modelId }))
  },
  /**
   * 查询设备型号
   */
  getDeviceModel2 (name) {
    return axios.post(base.manufacturer.getDeviceModel2, utils.postParamsArrayToJsonString({ name }))
  },
  /**
   * 查询设备型号
   */
  getDeviceModel3 (manufacturerId) {
    return axios.post(base.manufacturer.getDeviceModel3, utils.postParamsArrayToJsonString({ manufacturerId }))
  },
  /**
   * 删除设备型号
   */
  deleteDeviceModel (modelId) {
    return axios.post(base.manufacturer.deleteDeviceModel, utils.postParamsArrayToJsonString({ modelId }))
  },
}

export default manufacturer